$(document).ready(function() {

   $(document).on('click', '.collection-filter-close', function(e) {
      setTimeout(function() {
     $('html').removeClass('filter_lock_scroll');
    }, 1000);
     
    $("#mobile_filter_btn").click(); 
     $("#mobile_filter_btn").removeClass('hide_mob_apply');
    $('.mobile_apply_button').hide();
    return false;
});
  
  $(document).on('click', '.collection__sidebar__group p', function(event) {
  event.preventDefault();
  const $target = $(this);

  $target.toggleClass('is-active');
  $target.next().slideToggle();

  if ($target.next().next().length) {
    $target.next().next().slideToggle();
  }
});
  
  // Event listeners for filter controls

  // Define the media query
    const mediaQuery = window.matchMedia('(min-width: 768px)');

    // Function to execute when the media query matches
    function handleScreenSize(e) {
      if (e.matches) {
          function debounce(func, delay) {
          let timer;
          return function() {
          const context = this;
          const args = arguments;
          clearTimeout(timer);
          timer = setTimeout(() => {
          func.apply(context, args);
          }, delay);
          };
          }
       const debouncedFilterProducts = debounce(fetchAndFilterProducts, 1000);
        // Screen size is greater than 767px
        // Call your script here
        $(document).on('change', '.collection-nav  input', function() {
        fetchAndFilterProducts();
        });
         $(document).on('change', '.filter__price__fields input', function() {
       debouncedFilterProducts();
        });
        console.log('Screen size is greater than 767px');
        // Add your script logic here
      }
    else{
      
     $(document).on('click', '.collection-nav  label', function() {
        if ($(this).parent().hasClass('link--add')) {
          // Remove link--add class and add sidebar__item--active class
         $(this).parent().removeClass('link--add').addClass('sidebar__item--active link--remove' );
        } else if ($(this).parent().hasClass('sidebar__item--active')) {
          // Remove sidebar__item--active class and add link--add class
         $(this).parent().removeClass('sidebar__item--active link--remove').addClass('link--add');
        }
        });
      
        $(document).on('click', '#mobile_filter_btn', function(e) {
        $("#mobile_filter_btn").addClass('hide_mob_apply');
        $('.mobile_apply_button').show();
          $('.popout--sort #sort-list').removeClass('popout-list--visible-active');
      });
      

      $(document).on('click', '.mobile_apply_button', function() {
          $(this).hide();
          fetchAndFilterProducts();
          $("#mobile_filter_btn").removeClass('hide_mob_apply');
          const htmlTag = document.querySelector('html');
          $('.collection__sidebar__slider').removeClass('expanded');
          $('.collection__sidebar__slider').removeClass('expanded1');
          $('.collection__sidebar__slider').removeClass('expanding1');
         $('html').removeClass('filter_lock_scroll');
          htmlTag.removeAttribute('data-scroll-locked');
        
        });

  
      
    }
      
    }
    // Add the event listener to the media query
    mediaQuery.addListener(handleScreenSize);

    // Initial check
    handleScreenSize(mediaQuery);


      
    $(document).on('click', '#mobile_filter_btn', function(e) {
             $('html').addClass('filter_lock_scroll');
      $('.collection__sidebar__slider').toggleClass('expanding1');
              $('.collection__sidebar__slider').toggleClass('expanded1');
               const htmlTag = document.querySelector('html');
          if (htmlTag.hasAttribute('data-scroll-locked')) {
                         htmlTag.setAttribute('data-scroll-locked', '');
          } 
          else {
              htmlTag.removeAttribute('data-scroll-locked');

          }
      
    });
            
  

 
  
   $(document).on('click', '.active__filters__clear, .collection__sidebar__buttons a', function(event) {
         event.preventDefault();
         removeAllFilters();
     fetchAndFilterProducts();
   });

   $(document).on('click', '.popout-list__option', function(e) {
    e.preventDefault();
    let sortValue = $(this).data('value');
    $('#sort-list .popout-list__option').removeClass('active');
    $(this).addClass('active');
    fetchAndFilterProducts(sortValue);
  });
  
  // Function to remove all filters
  function removeAllFilters() {
    $('.collection-nav input').prop('checked', false);
    $('.filter__price__from input').val('0');
    $('.filter__price__to input').val($('.filter__price__to input').attr('max'));
  }

    $(document).on('click', '.active__filters__remove', function(e) {
    e.preventDefault();
  $('html').removeClass('filter_lock_scroll');
        var collection_handle = $('#collection_filter_main').attr('data-collection').replace('/collections/','');
    
      
        let url = '/collections/'+collection_handle+'?section_id=collection';
         url +=  '&'+$(this).attr('href').split('?')[1];

        console.log(url);
    history.replaceState(null, null, url.replace('section_id=collection',''));
      
       
      // Fetch products based on the constructed URL
        $.ajax({
          url: url,
          method: 'GET',
          success: function(data) {
            // Replace the product grid section with the updated HTML
             var filtered_data = $(data).find('.collection-'+collection_handle).html();
          //  console.log(filtered_data);
             $('#collection_filter_main').empty();
            $('#collection_filter_main').html(filtered_data);
            updateRangeLineAjax();
            window.wishlistInit();    
              $('.product-information .productdrawer-variant:first-child()').addClass('active-variant');

                const priceFromInput1 = document.querySelector('[data-field-price-min]');
          const priceToInput1 = document.querySelector('[data-field-price-max]');
              
           const minValue1 = parseFloat(priceFromInput1.value);
          const maxValue1 = parseFloat(priceToInput1.value);
           console.log(minValue1 + ' maxValue ajax ' +maxValue1 );
        
        
          const maxValue_filter = parseInt($('.filter__price__range').attr('data-se-max')); 
          // alert(maxValue_filter);
            var slider = document.getElementById('filter__price_slider_main');
        
                    noUiSlider.create(slider, {
                        start: [minValue, maxValue], // Initial values for the handles
                        connect: true, // Connect the two handles
                        range: {
                            'min': 0,
                            'max': maxValue_filter
                        }
                    });
        
                    // Update the displayed values when the slider is moved
                    slider.noUiSlider.on('update', function(values, handle) {
                        if (handle === 0) {
                            $('#min-value').text(Math.round(values[0]));
                           $("#filter-price-from-Price-1").val(Math.round(values[0]));
                        } else {
                            $('#max-value').text(Math.round(values[1]));
                           $("#filter-price-to-Price-1").val(Math.round(values[1]));
                        }
                    });
        
                 slider.noUiSlider.on('end', function(values) {
                      // Call your function here
                       function checkScreenSize() {
                          const width = window.innerWidth;
                         // alert('width' + width);
                          if (width > 768) {
                                fetchAndFilterProducts();
                                console.log('Desktop screensize');
                          } else {
                           console.log('mobile screensize');
                          }
                        }
                                       // Initial check
                          checkScreenSize();
                          
                          // Add event listener for window resize
                          window.addEventListener('resize', checkScreenSize);
                          setTimeout(function() {
                          $('html').removeClass('filter_lock_scroll');
                          }, 1000);
                    });
            
          },
          error: function(xhr, status, error) {
            console.error('Error fetching products:', error);
          }
        });
      
    });

  

  // Get the range line element
const rangeLine = document.querySelector('[data-range-line]');

// Get the input fields for price from and price to
const priceFromInput = document.querySelector('[data-field-price-min]');
const priceToInput = document.querySelector('[data-field-price-max]');

// Function to update the range line width and position
function updateRangeLine() {
    const minValue = parseFloat(priceFromInput.value);
    const maxValue = parseFloat(priceToInput.value);
    const range = maxValue - minValue;
    const maxRange = parseFloat(priceFromInput.getAttribute('max'));

    // Calculate the width and left position based on the input values
    const width = (range / maxRange) * 100;
    const left = (minValue / maxRange) * 100;

    // Set the width and left position of the range line
    rangeLine.style.width = width + '%';
    rangeLine.style.left = left + '%';
}

function updateRangeLineAjax() {
  const rangeLine = document.querySelector('[data-range-line]');
    const minValue = parseFloat(priceFromInput.value);
    const maxValue = parseFloat(priceToInput.value);
    const range = maxValue - minValue;
    const maxRange = parseFloat(priceFromInput.getAttribute('max'));

    // Calculate the width and left position based on the input values
    const width = (range / maxRange) * 100;
    const left = (minValue / maxRange) * 100;

    // Set the width and left position of the range line
    rangeLine.style.width = width + '%';
    rangeLine.style.left = left + '%';
}
  
// Initial call to set the range line based on default values
updateRangeLine();

  
  // Function to fetch and filter products based on user selections
  function fetchAndFilterProducts(sortValue = '') {
    // Construct the URL with selected filter parameters
    var collection_handle = $('#collection_filter_main').attr('data-collection').replace('/collections/','');
    // alert(collection_handle);
    let url = '/collections/'+collection_handle+'?section_id=collection';

    // Get selected filter values (availability, price, product type, metafields)
    let availability = $('#filter_opt_availability li input:checked').val();
    let minPrice = parseFloat($('.filter__price__from input').val());
    let maxPrice = parseFloat($('.filter__price__to input').val());
    let productTypes = [];

    
    $('#filter_opt_product_type input:checked').each(function() {
      productTypes.push($(this).val().replace('&' , '%26'));
    });
   
    // let metafieldValues = [];
    // $('.filter_opt_metafield input:checked').each(function() {
    //   metafieldValues.push($(this).val());
    // });

    let metafieldFilters = [];
    
    $('.filter_opt_metafield input:checked').each(function() {
      let namespace = '&filter.p.m.custom.';
      let key = $(this).data('name');
      let value = $(this).val().replaceAll('+', '%2B').replaceAll('&' , '%26');
      if (value) {
        metafieldFilters.push(`${namespace}${key}=${value}`);
      }
    });
    console.log(metafieldFilters);
    
    // Add filter parameters to the URL
    // &filter.v.availability=${availability}
    url += `&filter.v.price.gte=${minPrice}&filter.v.price.lte=${maxPrice}`;
   
    if (productTypes.length > 0) {
      url += `&filter.p.product_type=${productTypes.join(',')}`;
    }
    if (metafieldFilters.length > 0) {
      url += `${metafieldFilters.join('')}`;
       console.log(url);
    }
    
    // Add sorting parameter to the URL
    if (sortValue) {
      url += `&sort_by=${sortValue}`;
    }
   
    
    var filter_url = window.location.href.split('/collections')[0] + url.replace(' ', '%20').replace('section_id=collection', '');
      if (filter_url.includes("NaN")) {
        filter_url = window.location.href.split('?')[0];
      }

    // url =  url.replace('&', '%26');
    // console.log(url);
    
    history.replaceState(null, null, filter_url);
    
    // Fetch products based on the constructed URL
    $.ajax({
      url: url,
      method: 'GET',
      success: function(data) {
        // Replace the product grid section with the updated HTML
         var filtered_data = $(data).find('.collection-'+collection_handle).html();
         $('#collection_filter_main').empty();
        $('#collection_filter_main').html(filtered_data);
        window.wishlistInit();
        const rangeLine = document.querySelector('[data-range-line]');
        const minValue = minPrice;
        const maxValue = maxPrice;
        const range = maxValue - minValue;
        const maxRange = parseFloat(priceFromInput.getAttribute('max'));
        
        // Calculate the width and left position based on the input values
        const width = (range / maxRange) * 100;
        const left = (minValue / maxRange) * 100;
        
        // Set the width and left position of the range line
        rangeLine.style.width = width + '%';
        rangeLine.style.left = left + '%';
            $('html').removeAttr('data-scroll-locked');
           $('body').css('overflow', 'auto');
          $('.product-information .productdrawer-variant:first-child()').addClass('active-variant');
                 if(filter_url.includes('product_type')){
            $('#filter_opt_product_type p.collection__sidebar__heading').addClass('is-active');
           $('#filter_opt_product_type .collection-nav').css("display", "block"); 
             }
         if(filter_url.includes('ingredients')){
            $('.ingredients_filter  p.collection__sidebar__heading').addClass('is-active');
           $('.ingredients_filter  .collection-nav').css("display", "block"); 
             }
          if(filter_url.includes('concerns')){
            $('.concern_filter   p.collection__sidebar__heading').addClass('is-active');
           $('.concern_filter   .collection-nav').css("display", "block"); 
             }


        
          const maxValue_filter = parseInt($('.filter__price__range').attr('data-se-max')); 
          // alert(maxValue_filter);
            var slider = document.getElementById('filter__price_slider_main');
        
                    noUiSlider.create(slider, {
                        start: [minValue, maxValue], // Initial values for the handles
                        connect: true, // Connect the two handles
                        range: {
                            'min': 0,
                            'max': maxValue_filter
                        }
                    });
        
                    // Update the displayed values when the slider is moved
                    slider.noUiSlider.on('update', function(values, handle) {
                        if (handle === 0) {
                            $('#min-value').text(Math.round(values[0]));
                           $("#filter-price-from-Price-1").val(Math.round(values[0]));
                        } else {
                            $('#max-value').text(Math.round(values[1]));
                           $("#filter-price-to-Price-1").val(Math.round(values[1]));
                        }
                    });
        
                 slider.noUiSlider.on('end', function(values) {
                       // Call your function here
                       function checkScreenSize() {
                          const width = window.innerWidth;
                         // alert('width' + width);
                          if (width > 768) {
                                fetchAndFilterProducts();
                                console.log('Desktop screensize');
                          } else {
                           console.log('mobile screensize');
                          }
                        }
                                       // Initial check
                          checkScreenSize();
                          
                          // Add event listener for window resize
                          window.addEventListener('resize', checkScreenSize); 
                          setTimeout(function() {
                          $('html').removeClass('filter_lock_scroll');
                          }, 1000);
                    });
        
      },
      error: function(xhr, status, error) {
        console.error('Error fetching products:', error);
      }
    });
  }


  
    const minValue = parseFloat(priceFromInput.value);
    const maxValue = parseFloat(priceToInput.value);
  // alert(minValue + ' maxValue ' +maxValue );


  const maxValue_filter = parseInt($('.filter__price__range').attr('data-se-max')); 
  // alert(maxValue_filter);
    var slider = document.getElementById('filter__price_slider_main');

            noUiSlider.create(slider, {
                start: [minValue, maxValue], // Initial values for the handles
                connect: true, // Connect the two handles
                range: {
                    'min': 0,
                    'max': maxValue_filter
                }
            });

            // Update the displayed values when the slider is moved
            slider.noUiSlider.on('update', function(values, handle) {
                if (handle === 0) {
                    $('#min-value').text(Math.round(values[0]));
                   $("#filter-price-from-Price-1").val(Math.round(values[0]));
                } else {
                    $('#max-value').text(Math.round(values[1]));
                   $("#filter-price-to-Price-1").val(Math.round(values[1]));
                }
            });

         slider.noUiSlider.on('end', function(values) {
                // Call your function here
                       function checkScreenSize() {
                          const width = window.innerWidth;
                         // alert('width' + width);
                          if (width > 768) {
                                fetchAndFilterProducts();
                                console.log('Desktop screensize');
                          } else {
                           console.log('mobile screensize');
                          }
                        }
                                       // Initial check
                          checkScreenSize();
                          
                          // Add event listener for window resize
                          window.addEventListener('resize', checkScreenSize);
                setTimeout(function() {
                $('html').removeClass('filter_lock_scroll');
                }, 1000);
            });

  
});


